var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('banner'),_c('about'),_c('services'),_c('contact'),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }